import { TeamBox, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 82px 0 0;

  @media (max-width: 1024px) {
    margin-top: 87px;
    width: 100vw;
  }
`;

const SectionHeader = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;
  justify-content: space-between;

  .headerText {
    font-size: 72px;
  }

  @media (max-width: 1024px) {
    width: 100vw;

    .headerText {
      letter-spacing: -1.5px;
      margin-left: 17px;
      font-size: 48px;
    }
  }
`;

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  margin-top: 4px;

  @media (max-width: 1024px) {
    margin-top: 37px;
  }

  .scroll {
    ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}

    @media (max-width: 1024px) {
      overflow-x: scroll;
    }
  }
`;

const RedArea = styled.div`
  height: 547px;
  width: 1280px;
  align-self: center;
  background-color: ${theme.SECONDARY};
  margin-top: -554px;
  z-index: -1;

  @media (max-width: 1024px) {
    height: 294px;
    margin-top: -256px;
  }
`;

const TeamsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-left: ${(props) => props.extraPad};
  scroll-behavior: smooth;

  .team-box {
    margin-right: 40px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 25px;
  }

  @media (max-width: 1024px) {
    .team-box {
      margin-right: 16px;
      .team-box-image {
        width: 200px;
        height: 200px;
      }
    }
    padding: 0 13px;
  }
`;

const ArrowsContainer = styled.div`
  padding: 45px 0 0;
`;

const Teams = ({ data }) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    teamsRef = useRef(null),
    navigate = useNavigate();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  if (!data?.length) return null;

  return (
    <Container>
      <SectionHeader>
        <Text className="headerText" bold stencil spacing="-3.5px">
          {t('website.ourTeams')}
        </Text>

        <ArrowsContainer>
          <Arrows elem={teamsRef} />
        </ArrowsContainer>
      </SectionHeader>

      <BackgroundContainer>
        <div id="teamScroll" className="scroll" style={{ paddingLeft: extraPad }} ref={teamsRef}>
          <TeamsContainer>
            {data?.map((x, i) => (
              <TeamBox key={i} item={x} />
            ))}
          </TeamsContainer>
        </div>

        <RedArea />
      </BackgroundContainer>
    </Container>
  );
};

export default Teams;
